import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="posthog-reset"
export default class extends Controller {
  connect (): void {
    if (window.posthog?.__loaded) {
      window.posthog.reset()
    }

    // We could call window.segment.reset() here, but that clears the anonymous ID as well.
    // This makes tracking difficult because then we'll clear the anonymous ID as soon as
    // the member loads key pages like login, so we can't associate their previous activities
    // on the static site with their activities post-login. So, for now we skip calling
    // reset and see if that's better. In theory, a new login should overwrite all the old
    // identify information anyway.
  }
}
